<template>
    <!-- CAUTION: don't add the :open.sync here, to handle the close completely here in parent component! -->
    <modal-wrapper-inline
        v-if="showModal"
        :open="isOpen"
        :title="campaign.title"
        class="campaign-overlay"
        matomo-name="Kampagne"
        hide-close
        wide
    >
        <template #default>
            <div>
                <div class="image-wrapper">
                    <img :src="campaign.pictureURL" style="display: block; width: 100%" :alt="campaign.pictureName" />
                </div>

                <div class="campaign-overlay__content">
                    <p v-if="campaign.description">
                        {{ campaign.description }}
                    </p>
                    <ul class="checklist mb-2" v-if="campaign.productBenefits && campaign.productBenefits.length > 0">
                        <li v-for="(item, index) in campaign.productBenefits" :key="index">
                            {{ item }}
                        </li>
                    </ul>

                    <div class="level" v-if="hasCallToAction">
                        <div class="level-item">
                            <a class="btn btn--cta btn--rounded" :href="campaign.buyProductPageLink" target="_blank">
                                {{ campaign.buyProductActionLabel }}
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </template>

        <template #footer>
            <div class="flex-grid flex-h-end">
                <div class="campaign-overlay__footer-col">
                    <button @click="close(false)" class="btn btn--ghost btn--small">Nicht erneut anzeigen</button>
                </div>
                <div class="campaign-overlay__footer-col">
                    <button @click="close" class="btn btn--gray-dark btn--small">Schließen</button>
                </div>
            </div>
        </template>
    </modal-wrapper-inline>
</template>

<script>
import ModalWrapperInline from '@/components/modal/ModalWrapperInline';
import EventBus from '@/eventBus';
import { uniq, sortBy } from 'lodash';
import Api from '@/api';

export default {
    name: 'CampaignModal',
    components: { ModalWrapperInline },
    data() {
        return {
            showCampaign: true,
            campaign: null,
            isOpen: false,
        };
    },
    created() {
        this.getCampaign();
    },
    mounted() {
        EventBus.$on('open-campaign-modal', () => {
            setTimeout(() => {
                this.isOpen = true;
            }, 250);
        });
    },
    beforeDestroy() {
        EventBus.$off('open-campaign-modal');
    },
    watch: {
        customerCode() {
            this.getCampaign();
        },
    },
    computed: {
        customerCode() {
            return this.$store.getters['getCode'];
        },
        showModal() {
            return this.campaign !== null && this.showCampaign;
        },
        hasCallToAction() {
            return (
                this.campaign !== null &&
                this.campaign.hasOwnProperty('buyProductPageLink') &&
                this.campaign.buyProductPageLink.length > 0 &&
                this.campaign.hasOwnProperty('buyProductActionLabel') &&
                this.campaign.buyProductActionLabel.length > 0
            );
        },
    },
    methods: {
        getCampaign() {
            if (!this.$store.getters['isPrefilled']) {
                // if not prefilled just stop
                return;
            }

            let forbiddenCampaigns = [];

            if (localStorage.getItem('campaignData') !== null) {
                try {
                    forbiddenCampaigns = JSON.parse(localStorage.getItem('campaignData')).dontShowAgain;
                } catch (e) {
                    // if the parser is failing just continue and allow all campaigns
                    forbiddenCampaigns = [];
                }
            }

            const forbiddenIds = [];
            forbiddenCampaigns.forEach((campaignObjects) => {
                if (campaignObjects.code === this.customerCode) {
                    forbiddenIds.push(campaignObjects.campaign);
                }
            });

            Api.getCampaign()
                .then((response) => {
                    if (response.data && response.data.response && response.data.response.length > 1) {
                        let campaigns = response.data.response;
                        campaigns = campaigns.filter((campaign) => {
                            return !forbiddenIds.includes(campaign.id);
                        });
                        campaigns = sortBy(campaigns, ['priority']);

                        if (campaigns.length > 0) {
                            // just set campaign if one is left
                            this.campaign = Object.assign({}, campaigns[0]);
                        }
                    } else if (response.data && response.data.response && response.data.response.length === 1) {
                        if (!forbiddenCampaigns.includes(response.data.response[0].id)) {
                            this.campaign = Object.assign({}, response.data.response[0]);
                        }
                    }

                    if (this.campaign !== null) {
                        // let the browser preload the image so it will be cached
                        // (does not work when browser-cache is disabled!)
                        new Image().src = this.campaign.pictureURL;
                    }
                })
                .catch((e) => {
                    console.error('Could not fetch campaigns of the current user');
                    console.error(e);
                });
        },
        close(showAgain = true) {
            if (!showAgain) {
                let campaignStatus = {
                    dontShowAgain: [],
                };

                if (localStorage.getItem('campaignData') !== null) {
                    campaignStatus = JSON.parse(localStorage.getItem('campaignData'));
                }

                campaignStatus.dontShowAgain.push({
                    code: this.customerCode,
                    campaign: this.campaign.id,
                });
                campaignStatus.dontShowAgain = uniq(campaignStatus.dontShowAgain);

                localStorage.setItem('campaignData', JSON.stringify(campaignStatus));
            }

            this.showCampaign = false;
            this.isOpen = false;
        },
    },
};
</script>
